import { useState, useEffect, useRef } from 'react';
import Cookies from 'js-cookie';
import { X } from 'react-bootstrap-icons'
import { useWidgetContext } from '../../../context/WidgetContext';

export const PopupMessage = ({ message } : { message: string }) => {
  const container = useRef<HTMLDivElement>(null)
  const [showMessage, setShowMessage] = useState(false);
  const { isWidgetOpen } = useWidgetContext()

  useEffect(() => {
    if (!Cookies.get('osirus-popup-message-shown')) {
      setShowMessage(true);

      // Set a cookie to prevent the message from showing again for 24 hours
      Cookies.set('osirus-popup-message-shown', 'shown', { expires: 1 }); // expires in 1 day
    }
  }, []);

  useEffect(() => {
    if (isWidgetOpen) {
      setShowMessage(false);
    }
  }, [isWidgetOpen]);

  if (!showMessage) {
    return <></>
  }

  return (
    <>
      {showMessage && (
        <div ref={container} className='osirus-agent-popup-message'>
          <div>
            <p>{message}</p>
            <button type='button' onClick={() => setShowMessage(false)}>
              <X />
            </button>
          </div>
        </div>
      )}
    </>
  )
}
